import moment from 'moment'

export default function formatShiftTimes(startDate, startTime, endTime) {
    let startTimeFormatted = moment(startTime).utcOffset(startTime).format("HH:mmZ");
    let endTimeFormatted = moment(endTime).utcOffset(endTime).format("HH:mmZ");

    if (moment(startTime, 'h:mm A', true).isValid()) {
        startTimeFormatted = moment(startTime, 'h:mm A').format('HH:mmZ');
    }

    if (moment(endTime, 'h:mm A', true).isValid()) {
        endTimeFormatted = moment(endTime, 'h:mm A').format('HH:mmZ');
    }

    return {startTime: moment(startDate + " " + startTimeFormatted, "DD.MM.YYYY HH:mm"), endTime: moment(startDate + " " + endTimeFormatted, "DD.MM.YYYY HH:mm")};
}



/** WEBPACK FOOTER **
 ** ./app/src/utils/formatShiftTimes.js
 **/